import { Component, effect, input, output, signal, ViewChild } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { TranslatePipe } from '@ngx-translate/core';
import { environment } from 'src/environments/environment-hom';
import { RaButtonComponent } from '../ra-button';
import { RaIconComponent } from '../ra-icon/ra-icon.component';
import { RaModalComponent } from '../ra-modal/ra-modal.component';

@Component({
    selector: 'ra-modal-edit-text',
    templateUrl: 'ra-modal-edit-text.component.html',
    styleUrl: 'ra-modal-edit-text.component.scss',
    imports: [RaModalComponent, RaButtonComponent, FormsModule, RaIconComponent, TranslatePipe],
})
export class RaModalEditTextComponent {
    @ViewChild(RaModalComponent) modal!: RaModalComponent;
    public title = input<string>();
    public placeholder = input<string>();
    public modalSize = input<'small' | 'medium' | 'large'>('large');
    public editorHeight = input<number>(500);
    public showLimitCharacters = input<boolean>(true);
    public limitCharacters = input<number>(environment.LIMITES?.MAX_CHARACTERS);
    public value = input.required<any>();
    public save = output<string>();
    public close = output();
    public editorValue = signal<string>('');

    constructor() {
        effect(() => this.editorValue.set(String(this.value() ?? '')));
    }

    /**
     * Salva o valor do editor
     */
    public onSave = () => this.save.emit(this.editorValue());

    /**
     * Fecha o modal com animação
     */
    public onCancel(): void {
        this.modal?.handleClose();
        this.close.emit();
    }
}
